<template>
  <form role="form" class="form" method="post" id="contactFrm" @submit.stop.prevent>
    <div class="row">
      <div class="col-xs-12 col-md-4">
        <div class="form-group">
          <label class="sr-only" for="contactPurpose">Purpose</label>
          <select class="form-control input-lg" name="contactPurpose">
            <option value="" selected="selected">Area of Interest</option>
            <option>Products</option>
            <option>Tanks In Schools</option>
            <option>Aquaponic Education</option>
            <!-- Projects -->
          </select>
        </div>
      </div>

      <div class="col-xs-4 col-md-4">
        <div class="form-group">
          <label class="sr-only" for="contactName">Your Name</label>
          <input type="text" class="form-control input-lg" id="contactName" name="contactName" placeholder="Your Name">
        </div>
      </div>

      <div class="col-xs-12 col-md-4">
        <div class="form-group">
          <label class="sr-only" for="contactEmail">Email address</label>
          <input type="email" class="form-control input-lg" name="contactEmail" id="contactEmail" placeholder="Enter email">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-12">
        <div class="form-group">
          <label class="sr-only" for="contactMessage">Message</label>
          <textarea class="form-control input-lg" name="contactMessage" placeholder="Message" rows="12"></textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-12">
        <button type="submit" id="submitForm" class="btn btn-primary pull-right">Send</button>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  name: 'contact-form'
}
</script>